import DocPre from './Pre.vue';
import DocCode from './Code.vue';
import CodeNonParsable from './CodeNonParsable.vue';
import DocCodeBlock from './CodeBlock.vue';
import DocImage from './DocImage.vue';
import DocVideo from './DocVideo.vue';
import DocRouterLink from './DocRouterLink.vue';
import Youtube from './Youtube.vue';
import QuickLinks from './QuickLinks.vue';

export const MDX_COMPONENTS = {
	DocImage,
	DocVideo,
	DocRouterLink,
	DocCodeBlock,
	Youtube,
	QuickLinks,
	CodeNonParsable,
	// SectionTitle,
	pre: DocPre,
	DocCode: DocCode,
	a: DocRouterLink,
	// h2: DocH2,
	// table: DocTable,
};
